import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { CLOUD_FRONT_IMAGE_PATH } from 'src/constants/imagePath';

export function useCustomHeaderLogo() {
  const { headerParam } = useRouter().query;
  const [customLogo, setCustomLogo] = useState('');

  useEffect(() => {
    if (typeof headerParam === 'string') {
      setCustomLogo(headerParam);
    }
  }, [headerParam]);

  return logoMap.get(customLogo);
}

const logoMap = new Map([
  [
    'ququ', // 去趣
    {
      desktop: `${CLOUD_FRONT_IMAGE_PATH}/shared/logo/ququ.webp`,
      mobile: `${CLOUD_FRONT_IMAGE_PATH}/shared/logo/ququ.webp`
    }
  ],
  [
    'hachitour',
    {
      desktop: `${CLOUD_FRONT_IMAGE_PATH}/shared/logo/hachi-tour.webp`,
      mobile: `${CLOUD_FRONT_IMAGE_PATH}/shared/logo/hachi-tour.webp`
    }
  ],
  [
    'xianbei',
    {
      desktop: `${CLOUD_FRONT_IMAGE_PATH}/shared/logo/xianbei.webp`,
      mobile: `${CLOUD_FRONT_IMAGE_PATH}/shared/logo/xianbei.webp`
    }
  ],
  [
    'staytus',
    {
      desktop: `${CLOUD_FRONT_IMAGE_PATH}/shared/logo/staytus.webp`,
      mobile: `${CLOUD_FRONT_IMAGE_PATH}/shared/logo/staytus.webp`
    }
  ]
]);
